export const CONTEXT_AUTH = "RUTA40-APP-01";
export const CONTEXT_OVERLAY_STACK = "RUTA40-APP-02";

export const CONTEXT_SAVED_EMAIL = "RUTA40-APP-03";
export const CONTEXT_SAVED_PASSWORD = "RUTA40-APP-04";

export const CONTEXT_DONOT_SHOW_EVINFO = "RUTA40-APP-05";

export const SESSION_SHOW_MODAL = "showModal";
export const SESSION_SHOW_DRAWER = "showDrawer";

export const PAGE_WELCOME = "/welcome";
export const PAGE_LOGIN = "/login";
export const PAGE_SIGNUP = "/signup";
export const PAGE_TOS = "/tos";
export const PAGE_PRIVACY = "/privacy";
export const PAGE_FIND_USER = "/login/find";
export const PAGE_MYPAGE = "/mypage";
export const PAGE_UPDATE_MEMBER = "/update";
export const PAGE_WITHDRAW_MEMBER = "/withdraw";
export const PAGE_WITHDRAWL_INFO = "/withdrawlInfo";

export const PAGE_MAIN = "/main";
export const PAGE_FIND_EV_STATION = "/findEVStation";
export const PAGE_SETTINGS = "/settings";

export const PAGE_REGISTER_CAR = "/registerCar";
export const PAGE_REGISTER_CAR_METHOD = "/registerCarMethod";
export const PAGE_MANAGE_CAR = "/manageCar";
export const PAGE_CHANGE_PASSWORD = "/changePW";
export const PAGE_COMPANY_INFO = "/companyInfo";

export const PASSWORD_REGEXP = /^(?!.*[`~\\%"'<>\s;:,])(?!.*--)(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=[\]{}|?/])[A-Za-z\d!@#$%^&*()_\-+=[\]{}|?/]{8,20}$/;

export const EVENT_CLOSE_ALL_MODAL = "closeAllModal";
export const EVENT_CLOSE_ALL_DRAWER = "closeAllDrawer";
export const EVENT_RE_LOGIN = "reLogin";

export const EVENT_HEADER_INFO = "onInfoPressEvent";
export const EVENT_BATTERY = "onBatteryEvent";

export const PUSH_NOTIFICATION_BATTERY = "batteryPushNotification";
export const PUSH_NOTIFICATION_SUB_BATTERY = "subBatteryPushNotification";
export const PUSH_NOTIFICATION_DOOR_STATE = "doorStatePushNotification";
export const PUSH_NOTIFICATION_CAR_STATE = "carStatePushNotification";

export const EXTERNAL_EVENT_BACK = "backPressEvent";
export const EXTERNAL_EVENT_RESUME = "resumeAppEvent";

export type TypeLogin = {
    email: string;
    password: string;
};

export enum DoorType {
    DOOR,
    SWING_DOOR,
}
